import { render } from "./vabtn.vue?vue&type=template&id=55558bdc"
import script from "./vabtn.vue?vue&type=script&lang=js"
export * from "./vabtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__